import React, { useState } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Button, Grid, Alert } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import _ from 'lodash';
import PaymentLineItemRate from './PaymentLineItemRate';
import { generateTestId } from '../../../../../../utils';
import { rateFormDefault } from './line-item-config-form-utils';
import AddPaymentLineItemRateDialog from '../../../../../main/apps/ConfiguredApps/payment-line-item-configs/dialogs/AddPaymentLineItemRateDialog';
import AddExistingPaymentLineItemRateDialog from '../../../../../main/apps/ConfiguredApps/payment-line-item-configs/dialogs/AddExistingPaymentLineItemRateDialog';

function PaymentLineItemRates({ name }) {
    const { control, reset, getValues } = useFormContext();
    const [addPaymentLineItemRateDialogOpen, setAddPaymentLineItemRateDialogOpen] = useState(false);
    const [addExistingPaymentLineItemRateDialogOpen, setAddExistingPaymentLineItemRateDialogOpen] = useState(false);

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'rates',
    });

    const addNewRate = () => {
        append({ ...rateFormDefault });
    };

    const addExistingRate = (rate) => {
        append({ ...rate });
        // This seems required to ensure the form state is updated correctly, otherwise basic, tiered, and complex rates don't render properly
        reset(getValues());
    };

    return (
        <>
            <Grid>
                <Grid alignItems="center" className="mb-16">
                    <Grid item>
                        <Alert severity="info">Editing an existing rate on a new page will not show the changes on this form. However, saving this form will use your updated rate. To see your rate update on this form, refresh this page. Note: refreshing the page will remove other changes to the MooRule you have made.</Alert>
                    </Grid>
                </Grid>
                <Button aria-label="add" startIcon={<AddIcon />} variant="outlined" onClick={() => setAddPaymentLineItemRateDialogOpen(true)} data-testid={generateTestId(name, 'add-rate-btn')}>
                    Add Rate
                </Button>
                {fields.map((field, index) => {
                    return (
                        <Grid key={field.id} alignItems="center" className="mt-16">
                            <Grid item>
                                <PaymentLineItemRate {...field} remove={() => remove(index)} name={`${name}.${index}`} />
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
            <AddPaymentLineItemRateDialog dialogOpen={addPaymentLineItemRateDialogOpen} handleClose={() => setAddPaymentLineItemRateDialogOpen(false)} addNewRate={() => addNewRate()} addExistingRate={() => setAddExistingPaymentLineItemRateDialogOpen(true)} />
            <AddExistingPaymentLineItemRateDialog dialogOpen={addExistingPaymentLineItemRateDialogOpen} handleClose={() => setAddExistingPaymentLineItemRateDialogOpen(false)} handleAddExistingRate={addExistingRate} />
        </>
    );
}

export default PaymentLineItemRates;
